export default __webpack_public_path__ + "static/media/banner3.f4f207ff.webp";